import {useAtomValue} from 'jotai';
import {useCallback, useState} from 'react';

import {OmicronContent} from '@web-catalog/api';

import {
  omicronConfigAtom,
  omicronConfigClientAtom,
} from '@web-catalog/store/omicron';

import {BannerProps} from './types';
import {YandexBannerAd} from './YandexBannerAd';

type Props = {
  isEnabled: (omicron: OmicronContent) => boolean;
  getBlockId: (omicron: OmicronContent) => string;
  fallback?: React.ReactNode;
} & Pick<
  BannerProps,
  'placement' | 'adType' | 'bannerContainerClassName' | 'position'
>;

/**
 * при сср, если тоггл вкл, то отдаст верстку в которой забито место под баннер;
 *
 * на клиенте после инициализации клиентского атома омикрона,
 * если тоггл все еще вкл, то отрисует баннер, а если тоггл поменялся, то фолбек
 *
 * почему надо так разделять - если не дожидаться клиентского конфига,
 * а в клиентском конфиге переключиться с адфокса на рся (или наоборот),
 * будет фигня, потому что в yaContextCb попадут не те вызовы
 */
export const YandexBannerAdReservingSpace = ({
  isEnabled,
  getBlockId,
  fallback,
  bannerContainerClassName,
  placement,
  position,
  adType,
}: Props) => {
  const serverOmicron = useAtomValue(omicronConfigAtom);
  const clientOmicron = useAtomValue(omicronConfigClientAtom);
  const isClientConfigReady = !!clientOmicron.config_v;
  const adEnabled = isEnabled(
    (isClientConfigReady ? clientOmicron : serverOmicron).config,
  );
  const [adFailed, setAdFailed] = useState(false);
  const onRender = useCallback(() => setAdFailed(false), []);
  const onErrorOrNoAds = useCallback(() => setAdFailed(true), []);

  if (!isClientConfigReady) {
    // серверсайд или клиент при гидрации
    if (adEnabled) {
      // просто забиваем место под рекламу
      return <div className={bannerContainerClassName} />;
    }
    return fallback;
  }
  // клиент после гидрации
  if (!adEnabled || adFailed) {
    return fallback;
  }

  return (
    <YandexBannerAd
      blockId={getBlockId(clientOmicron.config)}
      placement={placement}
      bannerContainerClassName={bannerContainerClassName}
      position={position}
      adType={adType}
      onRender={onRender}
      onError={onErrorOrNoAds}
      onNoAds={onErrorOrNoAds}
    />
  );
};
